import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faCamera, faEye, faSquareXmark, faTriangleExclamation, faUpload } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime } from 'rxjs';
import { fadeIn, fadeInOut, fadeOut } from 'src/app/animations';
import { TipoDocumentoReembolso } from 'src/app/shared/enum/tipo-documento-reembolso';
import { TipoReembolso } from 'src/app/shared/enum/tipo-reembolso';
import { UfEnum } from 'src/app/shared/enum/uf';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { FormValidator } from 'src/app/shared/validators/Validator';
import Swal from 'sweetalert2';
import { AceitesService } from '../../../services/saude/aceites.service';
import { HealthService } from '../../../services/saude/health.service';
import { ReembolsoService } from '../../../services/saude/reembolso.service';
@Component({
  selector: 'app-reembolso',
  templateUrl: './reembolso.component.html',
  styleUrls: ['./reembolso.component.css'],
  animations: [fadeIn, fadeOut, fadeInOut]
})
export class ReembolsoComponent implements OnInit {
  typeToSearchText = true;
  seuTypeahead = new Subject<string>();
  ufs = Object.keys(UfEnum).filter((key: any) => !isNaN(UfEnum[key] as any));
  limiteCaracteres: number = 100;
  lastYear = new Date().setDate(new Date().getDate() - 366);
  options = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    allowZero: false,
    allowNegative: false
  };
  //Icones
  faUpload = faUpload;
  faCamera = faCamera;
  faSquareXmark = faSquareXmark;
  faEye = faEye;
  faTriangleExclamation = faTriangleExclamation;
  //Listas  
  valueProcedimento: any;
  listaCRM: any;
  beneficiaries!: any[];
  councils!: any[];
  documentTypeList!: any[];
  participationDregrees!: any[];
  procedures!: any;
  refundableGuides!: any[];
  refundTypeList!: any[];
  selectDocumentTypeList!: any[];
  file: any;
  pesquisaCpf: boolean = false;
  personate: boolean = false;
  loading: boolean = false;
  profissionalSelecionado: any;
  financialInvoiceList!: any[];
  financialReceiptList!: any[];
  //Instancias
  refundTypes: any = TipoReembolso;
  tipoDocumento: any = TipoDocumentoReembolso;
  today = new Date();
  totalProceduresValue: any = 0;
  dataContratacao: any;
  sessionErrorMessage: any = null;
  divergentValues: boolean = false;
  validator: any = FormValidator;
  formData = this.formBuilder.group({
    acceptedTerms: new FormControl(null, [Validators.requiredTrue]),
    beneficiaryId: new FormControl([Validators.required]),
    cnpj: new FormControl(null),
    comments: new FormControl(null),
    documentTypeId: new FormControl(0, [Validators.required]),
    executor: this.formBuilder.group({
      cpf: new FormControl('', []),
      councilNumber: new FormControl('', [Validators.required]),
      councilId: new FormControl(0, [Validators.required]),
      council: new FormControl(''),
      uf: new FormControl(''),
      profissionalExecutante: new FormControl('', [Validators.required]),
    }),
    participationDegreeId: new FormControl(0, [Validators.required]),
    procedures: this.formBuilder.array([]),
    procedureValueNotUsed: new FormControl(0, [Validators.min(0.01), Validators.max(99999.99)]),
    requestDate: new FormControl(null),
    requestedValue: new FormControl(0, [Validators.required, Validators.min(0.01), Validators.max(99999.99)]),
    refundTypeId: new FormControl(null, [Validators.required]),
    otherFiles: this.createOtherFile(false),
    // financialReceipt: this.createFinancialReceiptFile(false),
    financialReceipt: this.createFinancialReceiptFile(false),
    financialInvoice: this.createFinancialInvoiceFile(false),
    financialInvoiceMedical: this.createFinancialInvoiceMedicalFile(false),
    medicalReceipt: this.createMedicalReceiptFile(false),
    // financialInvoice: this.createFinancialInvoiceFile(false),
    anatomopathologicalReport: this.createAnatomopathologicalReportFile(false),
    medicalGuide: this.createMedicalGuide(false),
    medicalOrder: this.createMedicalOrder(false),
    cirurgicalDescription: this.createCirurgicalDescriptionFile(false),
    odontoDescription: this.createOdontoRecordFile(false),
    odontoProcedureDescription: this.createOdontoProcedureDescriptionFile(false, ''),
    // medicalPlan: this.createMedicalPlan(false),
    anestheticRecord: this.createAnestheticRecord(false),
    // pediatricRecord: this.createPediatricRecord(false),
    // partogram: this.createPartogram(false),    
  });
  constructor(private refundService: ReembolsoService, private userService: UsuarioService, private healthService: HealthService,
    private formBuilder: FormBuilder, private toast: ToastrService, private datePipe: DatePipe, private router: Router, private aceitesService: AceitesService) {
    this.loading = true;
    this.aceitesService.GetActualBankAccount().subscribe({
      next: (data: any) => {
        this.loading = false;
        Swal.fire({
          title: "Dados Bancários",
          text: "Antes de prosseguir com o reembolso, por gentileza confirmar os dados abaixo:",
          icon: "question",
          html: `<p style="text-align: left !important">Antes de prosseguir com o reembolso, por gentileza confirmar os dados abaixo:</p>
                  <ul style="text-align: justify; list-style-type: disc; margin-left: 1.5rem; font-size: 0.75rem;">
                    <li><b>Nome do banco:</b><span>${data.banco}</span></li>
                    <li><b>Nome do conta:</b><span>${data.conta}</span></li>
                    <li><b>Tipo de conta:</b><span>${data.tipoConta}</span></li>
                    <li><b>Número da agência:</b><span>${data.agencia}</span></li>
                  </ul>
                  <p style="text-align: center !important; font-size: 0.75rem; line-height: 1.25rem;">
                    <b>Caso os dados acima estejam incorretos, por gentileza entre em contato com a CENTRAL da Fundação Copel.</b>
                  </p>`,
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Continuar",
          confirmButtonColor: "#1A428A",
          denyButtonText: "Entrar em contato",
          denyButtonColor: "#89837F"
        }).then((result) => {
          if (result.isConfirmed) {
            this.aceitesService.PostActualBankAccount().subscribe();
          } else if (result.isDenied) {
            this.router.navigate(['contatos']);
          };
        });
      }
    }
    )
    this.inicializarFormularios();
    // this.modalService.open(ModalValidacaoDadosBancariosComponent, { windowClass: 'carteirinha-modal-size', centered: true });
  }
  ngOnInit(): void {
    this.loading = true;
    this.seuTypeahead.pipe(debounceTime(30000)).subscribe((term: string) => {
      this.loading = false;
      // Atualize o valor do formControl aqui
    });
  }
  fecharNome($event: any) { }
  customSearchNomeFn($event: any) {
    let executor = this.formData.controls.executor;
    let search = $event.term != null ? $event.term : null;
    executor.controls.profissionalExecutante.setValue($event.term);
    if (search != null && search?.length > 4) {
      this.loading = true;
      this.healthService.getBuscarMedico({
        numero: executor.value.councilNumber,
        conselho: executor.value.council,
        cpf: executor.value.cpf,
        nome: search,
        uf: executor.value.uf
      }).subscribe({
        next: (res: any) => {
          this.loading = false;
          this.listaCRM = res;
        },
        error: (err: any) => { }
      });
    } else {
      this.listaCRM = null;
    }
  }
  customSearchFn($event: any) {
    let executor = this.formData.controls.executor;
    let search = $event.term != null ? $event.term : null;
    executor.controls.councilNumber.setValue($event.term);
    if (search != null && search?.length > 2) {
      this.loading = true;
      this.healthService.getBuscarMedico({
        numero: search,
        conselho: executor.value.council,
        cpf: executor.value.cpf,
        nome: executor.value.profissionalExecutante,
        uf: executor.value.uf
      }).subscribe({
        next: (res: any) => {
          this.loading = false;
          this.listaCRM = res;
        },
        error: (err: any) => { }
      });
    } else {
      this.listaCRM = null;
    }
  }
  requestedValueChanged(event: any) {
    this.validateProceduresValue();
  }
  validateProceduresValue() {
    if (this.formData.controls.requestedValue.value && this.totalProceduresValue && this.totalProceduresValue.toFixed(2) != this.formData.controls.requestedValue.value?.toFixed(2)) {
      this.divergentValues = true;
      this.formData.controls.procedures.setErrors({ 'divergentValues': true });
    } else {
      this.divergentValues = false;
      this.formData.controls.procedures.setErrors(null);
    }
  }
  onCancel() {
    // this.initFormData();
  }
  public documentRequired(auditCode: any): boolean {
    return this.formData.controls.procedures.value.filter((p: any) => p.audit && p.audit.filter((ac: any) => ac.auditCodeId === auditCode).length > 0).length > 0
  }
  desabilitarCamposExecutor() {
    let executor = this.formData.controls.executor;
    executor.enable();
    if (this.formData.controls.refundTypeId.value == this.refundTypes.CONSULTA
      || this.formData.controls.refundTypeId.value == this.refundTypes.ODONTOLOGIA) {
      executor.controls.council.disable();
    }
  }
  crmSelected(event: any) {
    let profissional = this.formData.controls.executor.controls;
    // if(profissional != null && profissional.council != null && profissional.profissionalExecutante != null){
    // }
  }
  //  hasDuplicates = (set:any, items = []) => {
  //     return set.reduce((duplicates: any, item:any) => {
  //       return duplicates || items.includes(item) || (items.push(item), false);
  //     }, false);
  //  }
  hasDuplicates<T>(set: T[]): boolean {
    const uniqueItems: T[] = [];
    for (const item of set) {
      if (uniqueItems.includes(item)) {
        return true; // Já existe, encontramos uma duplicata
      } else {
        uniqueItems.push(item);
      }
    }
    return false; // Não há duplicatas
  }
  verificaValoresProcedimento<T>(set: T[]): any {
    let soma: number = set.reduce((soma: number, objeto: any) => {
      return soma + objeto.value;
    }, 0)
    // set.map( (obj:any) => {
    //   soma += obj.value;
    // });
    return soma;
  }
  dataChanged(tipoValor: string) {
    let form = this.formData.controls;
    if (tipoValor == 'financialReceipt') {
      form.financialInvoice.controls.executionDate.disable();
      form.financialReceipt.controls.executionDate.enable();
    } else {
      form.financialInvoice.controls.executionDate.enable();
      form.financialReceipt.controls.executionDate.disable();
    }
  }
  validaCpf() {
    let executor = this.formData.controls.executor.controls;
    let usuario: any;
    if (executor.cpf.value && executor.cpf.value?.length < 11) {
      this.pesquisaCpf = false;
    }
    if (executor.cpf.invalid && this.pesquisaCpf == false && this.profissionalSelecionado.cpf != null) {
      executor.councilNumber.setValue(null);
      executor.profissionalExecutante.setValue(null);
      executor.uf.setValue(null);
      executor.councilNumber.enable();
      executor.profissionalExecutante.enable();
      executor.uf.enable();
      this.profissionalSelecionado = null;
    }
    if (this.formData.get('executor.cpf')?.valid) {
      this.loading = true;
      this.healthService.getBuscarMedico({
        numero: (this.formData.get('executor.councilNumber')?.value != null ? this.formData.get('executor.councilNumber')?.value : ''),
        conselho: (this.formData.get('executor.council')?.value != null ? this.formData.get('executor.council')?.value : ''),
        cpf: (this.formData.get('executor.cpf')?.value != null ? this.formData.get('executor.cpf')?.value : ''),
        nome: (this.formData.get('executor.profissionalExecutante')?.value != null ? this.formData.get('executor.profissionalExecutante')?.value : ''),
        uf: (this.formData.get('executor.uf')?.value != null ? this.formData.get('executor.uf')?.value : '')
      }).subscribe({
        next: (res: any) => {
          this.loading = false;
          usuario = res[0];
          if (res && res?.length > 0) {
            if (usuario.sigla != 'CRM' && this.formData.get('refundTypeId')?.value == this.refundTypes.CONSULTA) {
              this.toast.error('Por gentileza informe apenas médicos com CRM!');
            } else if (usuario.sigla != 'CRO' && this.formData.get('refundTypeId')?.value == this.refundTypes.ODONTOLOGIA) {
              this.toast.error('Por gentileza informe apenas Dentistas com CRO!');
            }
            this.profissionalSelecionado = res[0];
            this.pesquisaCpf = true;
            this.formData.get('executor.cpf')?.setValue(usuario.cpf);
            this.formData.get('executor.councilNumber')?.setValue(usuario.conselho);
            this.formData.get('executor.profissionalExecutante')?.setValue(usuario.nome);
            this.formData.get('executor.uf')?.setValue(usuario.uf);
            this.formData.get('executor.councilNumber')?.disable();
            this.formData.get('executor.profissionalExecutante')?.disable();
            this.formData.get('executor.uf')?.disable();
          } else {
            this.pesquisaCpf = false;
          }
        },
        error: (err: any) => { }
      });
    }
  }
  validarCampos($event: any, tipo: string) {
    let executor = this.formData.controls.executor.controls;
    if ($event.code == 'Backspace' && tipo == 'profissionalExecutante' || $event.code == 'Escape' && tipo == 'profissionalExecutante') {
      executor.profissionalExecutante.reset();
    } else if ($event.code == 'Backspace' && tipo == 'conselho' || $event.code == 'Escape' && tipo == 'conselho') {
      executor.councilNumber.reset();
    }
    if ($event.code == 'Backspace' && this.profissionalSelecionado && this.profissionalSelecionado.cpf != null || $event.code == 'Esc' && this.profissionalSelecionado && this.profissionalSelecionado.cpf != null) {
      if (this.formData.get('refundTypeId')?.value !== this.refundTypes.CONSULTA && this.formData.get('refundTypeId')?.value !== this.refundTypes.ODONTOLOGIA) {
        this.formData.get('executor.council')?.reset();
        this.formData.get('executor.council')?.enable();
        this.formData.get('executor.councilId')?.reset();
        this.formData.get('executor.councilId')?.enable();
      }
      this.listaCRM = null;
      if (tipo == 'profissionalExecutante') {
        this.profissionalSelecionado != null ? this.formData.get('executor.councilNumber')?.reset() : '';
        this.formData.get('executor.uf')?.reset();
        this.formData.get('executor.cpf')?.reset();
        this.formData.get('executor.uf')?.enable();
        this.formData.get('executor.councilNumber')?.enable();
        this.formData.get('documentTypeId')?.value == this.tipoDocumento.RECIBO ? this.formData.get('executor.cpf')?.enable() : '';
      } else {
        this.profissionalSelecionado != null ? this.formData.get('executor.profissionalExecutante')?.reset() : '';
        this.formData.get('executor.uf')?.reset();
        this.formData.get('executor.cpf')?.reset();
        this.formData.get('executor.profissionalExecutante')?.enable();
        this.formData.get('executor.uf')?.enable();
        this.formData.get('executor.councilNumber')?.enable();
        this.formData.get('executor.cpf')?.enable();
      }
      this.profissionalSelecionado = null;
    }
  }
  inicializarFormularios() {
    this.refundService.getRefundTypes().subscribe((res: any) => { this.refundTypeList = res; });
    this.refundService.getRefundDocumentTypes().subscribe((res: any) => {
      this.documentTypeList = res;
      this.selectDocumentTypeList = res.filter((v: any) => v.selectable === true);
    });
    this.userService.getBeneficiaries().subscribe((res: any) => { this.beneficiaries = res; });
    this.userService.getPersonate().subscribe((res: any) => { this.personate = res; });
    this.healthService.getProfessionalCouncil().subscribe((res: any) => { this.councils = res });
  }
  tipoReembolsoSelecionado(event: any) {
    this.formData.controls.requestedValue.removeValidators([Validators.required, Validators.min(0.01), Validators.max(99999.99)]);
    this.clearFinancialDocumentFiles();
    let executor = this.formData.controls.executor;
    executor.enable();
    switch (event.id) {
      case TipoReembolso.CONSULTA:
        this.formData.get("participationDegreeId")?.setValue(12);//Clinico 
        executor.controls.councilId.setValue(6);
        executor.controls.council.setValue('CRM');
        executor.controls.councilId.disable();
        break;
      case TipoReembolso.MEDICAMENTO:
        this.formData.controls.documentTypeId
        this.formData.get("documentTypeId")?.patchValue(1, { onlySelf: true });
        executor.disable();
        executor.updateValueAndValidity();
        this.formData.get("participationDegreeId")?.setValue(12);//Clinico          
        this.formData.controls.requestedValue.addValidators([Validators.required, Validators.min(0.01), Validators.max(99999.99)]);
        this.formData.controls.financialInvoiceMedical = this.createFinancialInvoiceMedicalFile(true);
        this.formData.controls.medicalReceipt = this.createMedicalReceiptFile(true);
        break;
      case TipoReembolso.ODONTOLOGIA:
        this.formData.controls.odontoDescription = this.createOdontoRecordFile(true);
        this.formData.get("participationDegreeId")?.setValue(12);//Clinico
        executor.controls.councilId.setValue(9);
        executor.controls.council.setValue('CRO');
        executor.controls.councilId.disable();
        Swal.fire({
          title: 'Para agilizar o seu processo já deixe os arquivos preparados em seu computador',
          icon: 'info',
          showConfirmButton: true,
          confirmButtonColor: '#1A428A',
          confirmButtonText: 'Continuar',
          focusConfirm: false,
          html: `
                  <ul>
                    <li>Nota Fiscal / Recibo</li>
                    <li>Ficha Odontológica - FOA</li>
                    <li>Perícia Inicial / Final</li>
                    <li>Exames de Raio-x / laudos</li>
                  </ul>                    
                `,
          footer: `<a class="font-size: 14px;" href="https://fcopel.org.br/wp-content/uploads/2022/01/REFERENCIAL-ODONTOLOGIA-REEMBOLSO-2022.pdf" target="_blank">
                      Consulte o referencial odontológico da Fundação Copel clicando aqui *
                      </a>`,
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });
        break;
      case TipoReembolso.TERAPIAS:
        this.formData.get("participationDegreeId")?.setValue(12); //Clinico
        this.formData.controls.medicalGuide = this.createMedicalGuide(true);
        Swal.fire({
          title: 'Para agilizar o seu processo já deixe os arquivos preparados em seu computador',
          icon: 'info',
          showConfirmButton: true,
          confirmButtonColor: '#1A428A',
          confirmButtonText: 'Continuar',
          focusConfirm: false,
          html: `
              <section style="text-align: justify; margin-left: 10%;">
                    <p style="font-weight: 500;">Psicologia</p>
                  <ol style="margin-left: 0.5rem; list-style: inside;">
                    <li>Nota Fiscal / Recibo</li>
                    <li>Plano de tratamento</li>
                    <li>Pedido médico atualizado</li>
                    <li>Datas das sessões.</li>
                  </ol>      
                    <p style="font-weight: 500;">Fonoaudiologia/TO</p>
                  <ol style="margin-left: 0.5rem; list-style: inside;">
                    <li>Nota fiscal/Recibo</li>
                    <li>Pedido médico atualizado 6 meses</li>                             
                  </ol>                 
                    <p style="font-weight: 500;">Fisioterapia</p>
                  <ol style="margin-left: 0.5rem; list-style: inside;">
                    <li>Nota Fiscal / Recibo</li>
                    <li>Pedido médico mensal</li>                                 
                  </ol>                 
              </section>
                `,
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });
        break;
      case TipoReembolso.EXAMES:
        this.formData.get("participationDegreeId")?.setValue(12); //Clinico
        this.formData.controls.medicalGuide = this.createMedicalGuide(true);
        break;
      case TipoReembolso.HONORARIOS_MEDICOS:
        this.formData.get("executor.councilNumber")?.setValidators([Validators.required]);
        this.formData.get("executor.councilId")?.setValidators([Validators.required]);
        this.formData.get("executor.council")?.setValidators([Validators.required]);
        this.formData.controls.anatomopathologicalReport = this.createAnatomopathologicalReportFile(true);
        this.formData.controls.medicalGuide = this.createMedicalGuide(true);
        break;
      case TipoReembolso.INSTRUMENTACAO_CIRURGICA:
        this.formData.get("participationDegreeId")?.setValue(5);//Clinico
        this.formData.controls.cirurgicalDescription = this.createCirurgicalDescriptionFile(true);
        this.formData.controls.medicalGuide = this.createMedicalGuide(true);
        this.formData.controls.anatomopathologicalReport = this.createAnatomopathologicalReportFile(true);
        break;
    }
    this.validators(event.id);
  }
  beneficiarioSelecionado(event: any) {
    this.onClearAll();
    let beneficio = this.formData.controls.refundTypeId.value;
    if (beneficio == TipoReembolso.TERAPIAS || beneficio == TipoReembolso.EXAMES || beneficio == TipoReembolso.HONORARIOS_MEDICOS ||
      beneficio == TipoReembolso.INSTRUMENTACAO_CIRURGICA) {
      this.loading = true;
      this.refundService.getRefundableGuides({ beneficiaryId: this.formData.value.beneficiaryId, refundTypeId: this.formData.controls.refundTypeId.value }).subscribe((res: any) => {
        this.loading = false;
        this.refundableGuides = res.map((i: any) => { i.guideInfo = i.code + ' - ' + i.provider + ' - ' + this.datePipe.transform(i.serviceDate, 'dd/MM/yyyy'); return i; });
      });
    }
    if (this.formData.controls.refundTypeId.value != TipoReembolso.MEDICAMENTO) {
      this.formData.controls.documentTypeId.reset();
    }
    this.loading = true;
    this.healthService.getBeneficiaryAndHealthData().subscribe((res: any) => {
      this.loading = false;
      res.filter((user: any) => {
        if (user.cpf == event.id) {
          let minhaData = new Date(user.coverageInitialDate);
          let ano = minhaData.getFullYear();
          let mes = ('0' + (minhaData.getMonth() + 1)).slice(-2); // O mês é baseado em zero
          let dia = ('0' + minhaData.getDate()).slice(-2);
          this.dataContratacao = `${ano}-${mes}-${dia}`;
        }
      });
    });
  }
  sessionDataChanged(procedureCode: any, session: any, $event: any, index: any) {
    var date = moment($event.target.value);
    let element = document.getElementById(`warningSession_${index}_${session.id}`);
    if (date.isValid() && date.isAfter(this.lastYear) && date.isSameOrBefore(this.today) && !session.notDone) {
      let procedure: any = this.formData.controls.procedures.value.find((x: any) => x.code === procedureCode);
      procedure.sessions[session.id - 1].date = date.format("YYYY-MM-DD");
      if (element && !element.classList.contains('d-none')) {
        element.classList.add('d-none');
      }
    } else {
      if (element && element.classList.contains('d-none')) {
        element.classList.remove('d-none');
      }
    }
  }
  sessionCheckChanged(procedureCode: any, session: any, $event: any, index: any) {
    let procedure: any = this.formData.value.procedures?.find((x: any) => x.code === procedureCode);
    procedure.sessions[session.id - 1].notDone = $event.target.checked;
    let element = document.getElementById(`warningSession_${index}_${session.id}`);
    if ($event.target.checked && element && !element.classList.contains('d-none')) {
      element.classList.add('d-none');
    }
  }
  councilChanged(event: any) {
    this.formData.get('executor.councilId')?.patchValue(event.id);
    this.formData.get('executor.council')?.patchValue(event.name);
  }
  tipoConcelhoSelecionado(event: any, campo: string) {
    if (event != null) {
      this.profissionalSelecionado = event;
      let executor = this.formData.get('executor') as FormGroup;
      executor.get('councilNumber')?.setValue(event.conselho);
      executor.get('cpf')?.setValue(event.cpf);
      executor.get('uf')?.setValue(event.uf);
      executor.get('profissionalExecutante')?.setValue(event.nome);
      executor.get('council')?.setValue(event.sigla);
      this.verificaCampoNull('executor.uf');
      this.verificaCampoNull('executor.councilNumber');
      this.verificaCampoNull('executor.profissionalExecutante');
      executor.get(campo)?.enable();
      this.councils.forEach((a: any) => {
        if (a.name == event.sigla) {
          executor.get('councilId')?.setValue(a.id);
          executor.get('councilId')?.disable();
        }
      });
      if (this.formData.controls.documentTypeId.value == TipoDocumentoReembolso.RECIBO) {
        this.verificaCampoNull('executor.cpf');
      }
    }
  }
  verificaCampoNull(form: string) {
    if (form.includes('cpf')) {
      this.formData.get(form)?.updateValueAndValidity();
      if (this.formData.get(form)?.invalid) {
        this.toast.error('CPF inválido!');
        this.formData.get(form)?.enable();
        this.formData.get(form)?.markAsTouched();
      } else {
        this.formData.get(form)?.disable();
      }
    } else if (this.formData.get(form)?.value?.length > 0) {
      this.formData.get(form)?.disable();
    }
  }
  resetForm() {
    this.formData.reset();
  }
  desabilitaValidators() {
    Object.keys(this.formData.controls).forEach((controlName: any) => {
      const control = this.formData.get(controlName) as FormControl;
      // const hasRequiredValidator = control.validator ? control.validator({} as AbstractControl)?.hasOwnProperty('required') : false;
      if (controlName != 'acceptedTerms' && controlName != 'authorId' && controlName != 'beneficiaryId' && controlName != 'refundTypeId' &&
        controlName != 'requestedValue' && controlName != 'documentTypeId') {
        control.clearValidators();
      }
    });
    this.formData.updateValueAndValidity();
  }
  desabilitaValidatorsDocumentosRecibo() {
    const form = this.formData.get('financialReceipt');
    // form?.get('file')?.setValidators([]);
    // form?.get('issueDate')?.setValidators([]);
    // form?.get('nome')?.setValidators([]);
    // form?.get('tipoDocumento')?.setValidators([]);
    // form?.get('file')?.updateValueAndValidity;
    // form?.get('issueDate')?.updateValueAndValidity;
    // form?.get('nome')?.updateValueAndValidity;
    // form?.get('tipoDocumento')?.updateValueAndValidity;
    // Object.keys(this.formData.controls['financialReceipt'].controls).forEach((controlName:any) => {
    //   const control = this.formData.controls['financialReceipt'].get(controlName) as FormControl;
    //   control.setValidators(null);   
    //   control.clearValidators();
    //   control.updateValueAndValidity;
    // });   
    Object.keys(this.formData.controls['financialReceipt'].controls).forEach((controlName: any) => {
      form?.get(controlName)?.setValidators([]);
      form?.get(controlName)?.updateValueAndValidity();
    });
  }
  desabilitaValidatorsDocumentos() {
    const form = this.formData.get('financialInvoice');
    Object.keys(this.formData.controls['financialInvoice'].controls).forEach((controlName: any) => {
      form?.get(controlName)?.setValidators([]);
      form?.get(controlName)?.updateValueAndValidity();
    });
  }
  participationDegreeChanged(event: any) {
    if (event.description == "Cirurgião" || event.description.includes("Auxiliar")) {
      this.formData.controls.cirurgicalDescription = this.createCirurgicalDescriptionFile(true);
      this.formData.controls.anatomopathologicalReport = this.createAnatomopathologicalReportFile(true);
    } else if (event.description == "Anestesista") {
      this.formData.controls.cirurgicalDescription = this.createCirurgicalDescriptionFile(true);
      this.formData.controls.anatomopathologicalReport = this.createAnatomopathologicalReportFile(true);
      this.formData.controls.anestheticRecord = this.createAnestheticRecord(true);
    } else {
      this.formData.controls.cirurgicalDescription = this.createCirurgicalDescriptionFile(false);
    }
    this.formData.get("executor.cpf")?.updateValueAndValidity();
    this.formData.get('participationDegreeId')?.setValue(event.id);
  }
  guiaAutorizacaoAlterada(event: any) {
    this.totalProceduresValue = 0;
    this.formData.controls.procedures.reset();
    this.formData.controls.procedureValueNotUsed.setValue(null);
    this.formData.controls.procedures.updateValueAndValidity();
    this.formData.controls.procedureValueNotUsed.updateValueAndValidity();
    // this.formData.controls.participationDegreeId.reset();
    this.formData.controls.anestheticRecord.reset();
    // this.formData.controls.cirurgicalDescription = this.createCirurgicalDescriptionFile(false);
    this.divergentValues = false;
    this.participationDregrees = []
    this.formData.get('medicalGuide.number')?.patchValue(event.code);
    this.sessionErrorMessage = null;
    if (event.healthHistoryMaterials) {
      event.healthHistoryMaterials.forEach((element: any) => {
        this.formData.controls.procedures.value.push({ type: 1,/*Medico */ code: element.code, description: element.name, value: 0, quantity: element.amount });
      });
    }
    if (event.healthHistoryProcedures) {
      event.healthHistoryProcedures.forEach((element: any) => {
        let sessionsList = null;
        if (this.formData.controls.refundTypeId.value == this.refundTypes.TERAPIAS) {
          sessionsList = [];
          for (let i = 0; i < element.amount; i++) {
            sessionsList.push({ id: i + 1, notDone: false, date: null })
          }
        }
        this.formData.value.procedures?.push({ type: 1,/*Medico */code: element.code, description: element.name, value: 0, sessions: sessionsList, quantity: element.amount, audit: element.medicalProcedureAuditCode });
        if (element.medicalProcedureParticipationDegree != null) {
          element.medicalProcedureParticipationDegree.forEach((pd: any) => {
            if (!this.participationDregrees.find(function (b) { return b.id == pd.participationDegreeId }))
              this.participationDregrees.push(pd.participationDegree);
          });
        }
      });
    }
    this.procedures = this.formData.value.procedures;
    this.procedures.forEach((element: any) => {
      element.audit.forEach((element2: any) => {
        switch (element2.auditCodeId) {
          case 25:
            this.formData.controls.medicalOrder = this.createMedicalOrder(true);
            break;
          //TODO add other file types
        }
      });
    });
  }
  validators(value: number) {
    const form = this.formData.get('executor');
    this.desabilitaValidators();
    switch (value) {
      case TipoReembolso.CONSULTA:
        this.validatorsDefault();
        break;
      case TipoReembolso.MEDICAMENTO:
        form?.get('cpf')?.clearValidators();
        form?.get('councilId')?.clearValidators();
        form?.get('councilNumber')?.clearValidators();
        form?.get('cpf')?.updateValueAndValidity();
        form?.get('councilId')?.updateValueAndValidity();
        form?.get('councilNumber')?.updateValueAndValidity();
        break;
      case TipoReembolso.INSTRUMENTACAO_CIRURGICA:
        this.validatorsDefault();
        break;
      case TipoReembolso.ODONTOLOGIA:
        this.validatorsDefault();
        break;
      case TipoReembolso.TERAPIAS:
        this.validatorsDefault();
        break;
      case TipoReembolso.EXAMES:
        this.validatorsDefault();
        break;
      case TipoReembolso.HONORARIOS_MEDICOS:
        this.validatorsDefault();
        break;
    }
  }
  validatorsDefault() {
    const form = this.formData.get('executor');
    form?.get('cpf')?.setValidators([Validators.required, FormValidator.validCpfField]);
    form?.get('councilId')?.setValidators([Validators.required]);
    form?.get('councilNumber')?.setValidators([Validators.required]);
    form?.get('cpf')?.updateValueAndValidity();
    form?.get('councilId')?.updateValueAndValidity();
    form?.get('councilNumber')?.updateValueAndValidity();
  }
  procedureValueChanged(procedureCode: any, event: string, index?: any) {
    let procedure: any = this.formData.value.procedures?.find((x: any) => x.code === procedureCode);
    // procedure.value = Number((JSON.stringify(event).replace('.', '')).replace(',', '.')) / procedure?.quantity;
    procedure.value = Number(event) / procedure?.quantity;
    this.totalProceduresValue = this.formData.value.procedures?.map((a: any) => a.value * a.quantity).reduce(function (a, b) {
      return a + b;
    });
    this.validateProceduresValue();
  }
  tipoDocumentoSelecionado(event: any) {
    this.onClearAll();
    this.formData.controls.requestedValue.removeValidators([Validators.required, Validators.min(0.01), Validators.max(99999.99)]);
    if (this.formData.controls.documentTypeId.value == TipoDocumentoReembolso.RECIBO) {
      this.formData.controls.financialReceipt = this.createFinancialReceiptFile(true);
      this.formData.controls.financialInvoice.disable();
      this.formData.controls.financialInvoice.updateValueAndValidity();
      this.formData.get("executor.cpf")?.setValidators([Validators.required, FormValidator.validCpfField]);
    } else if (this.formData.controls.documentTypeId.value == TipoDocumentoReembolso.NOTA_FISCAL) {
      this.formData.controls.financialInvoice = this.createFinancialInvoiceFile(true);
      this.formData.controls.financialReceipt.disable();
      this.formData.controls.financialReceipt.updateValueAndValidity();
      this.formData.get("executor.cpf")?.clearValidators();
      this.formData.get("executor.cpf")?.updateValueAndValidity();
    }
    this.formData.get('financialInvoice.executionDate')?.disable();
    this.formData.get('financialReceipt.executionDate')?.disable();
    this.customSearchNomeFn('');
    this.customSearchFn('');
  }
  adicionarArquivos(fileType: string, event: any) {
    switch (fileType) {
      case 'otherFiles':
        this.formData.get('otherFiles.file')?.setValue(event);
        break;
      case 'medicalReceipt':
        this.formData.get('medicalReceipt.file')?.setValue(event);
        break;
      case 'odontoDescription':
        this.formData.get('odontoDescription.file')?.setValue(event);
        break;
      case 'cirurgicalDescription':
        this.formData.get('cirurgicalDescription.file')?.setValue(event);
        break;
      case 'anatomopathologicalReport':
        this.formData.get('anatomopathologicalReport.file')?.setValue(event);
        break;
      case 'medicalOrder':
        this.formData.get('medicalOrder.file')?.setValue(event);
        break;
      case 'financialInvoice':
        this.formData.get('financialInvoice.file')?.setValue(event);
        break;
      case 'financialInvoiceMedical':
        this.formData.get('financialInvoiceMedical.file')?.setValue(event);
        break;
      case 'financialReceipt':
        this.formData.get('financialReceipt.file')?.setValue(event);
        break;
      case 'anestheticRecord':
        this.formData.get('anestheticRecord.file')?.setValue(event);
        break;
    }
  }
  cancelarFormulario() {
    this.formData.reset();
  }
  onClearAll() {
    let executor = this.formData.controls.executor;
    if (this.formData.controls.refundTypeId.value == this.refundTypes.CONSULTA || this.formData.controls.refundTypeId.value == this.refundTypes.ODONTOLOGIA) {
      executor.controls.cpf.reset();
      executor.controls.profissionalExecutante.reset();
      executor.controls.councilNumber.reset();
      executor.controls.uf.reset();
      this.listaCRM = null;
    } else {
      executor.reset();
      this.listaCRM = null;
    }
  }
  removeFile(fileType: string, index: number) {
    const lista: any = this.formData.get(`${fileType}.file`)?.value;
    lista.splice(index, 1);
    this.formData.get(`${fileType}.file`)?.updateValueAndValidity();
  }
  createOtherFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl('otherFiles'),
      file: new FormControl(null),
      documentTypeId: new FormControl(TipoDocumentoReembolso.OUTROS,),
    })
  }
  createFinancialInvoiceFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'financialInvoice', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.NOTA_FISCAL, disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
      cnpj: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      issueDate: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      executionDate: new FormControl({ value: null, disabled: !enabled }, [Validators.required, FormValidator.ValidaData]),
      number: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
    })
  }
  createMedicalReceiptFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl('medicalReceipt'),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.RECEITA_MEDICA, disabled: !enabled }, [Validators.required]),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  createFinancialInvoiceMedicalFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'financialInvoice', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.NOTA_FISCAL, disabled: !enabled }, [Validators.required]),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled })
    })
  }
  createCirurgicalDescriptionFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'cirurgicalDescription', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.DESCRICAO_CIRURGICA, disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  createAnatomopathologicalReportFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl('anatomopathologicalReport'),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.LAUDO_ANATOMOPATOLOGICO, disabled: !enabled }, [Validators.required]),
      file: new FormControl({ value: null, disabled: !enabled }/*, [FileValidator.validate]*/),
      fileName: new FormControl({ value: null, disabled: !enabled }/*, [Validators.required]*/),
      MD5: new FormControl({ value: null, disabled: !enabled }/*, [Validators.required]*/)
    })
  }
  createFinancialReceiptFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'financialReceipt', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.RECIBO, disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
      issueDate: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      executionDate: new FormControl({ value: null, disabled: !enabled }, [Validators.required, FormValidator.ValidaData]),
    });
  }
  createMedicalGuide(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'medicalGuide', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.GUIA_AUTORIZACAO, disabled: !enabled }, [Validators.required]),
      number: new FormControl({ value: null, disabled: !enabled }, [Validators.required])
    })
  }
  createMedicalOrder(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'medicalOrder', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.PEDIDO_MEDICO, disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  createOdontoRecordFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'odontoDescription', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.FICHA_ODONTO, disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileName: new FormControl({ value: null, disabled: !enabled }),
      contentType: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  createAnestheticRecord(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'anestheticRecord', disabled: !enabled }),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.FICHA_ANESTESICA, disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      // binary: new FormControl(null, [Validators.required]),
      filename: new FormControl({ value: null, disabled: !enabled }),
      MD5: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  createOdontoDescriptionFile(enabled: boolean) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'odontoDescription', disabled: !enabled }),
      file: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      procedures: new FormControl({ value: [], disabled: !enabled }),
      // documentTypeId: new FormControl( {value: TipoDocumentoReembolso.FICHA_ODONTO_AUDIT, disabled: !enabled} ),
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.FICHA_ODONTO_AUDIT, disabled: !enabled }),
    })
  }
  createOdontoProcedureDescriptionFile(enabled: boolean, fileDescription: string) {
    return this.formBuilder.group({
      name: new FormControl({ value: 'odontoProcedureDescription', disabled: !enabled }),
      files: new FormControl({ value: null, disabled: !enabled }, [Validators.required]),
      fileDescription: new FormControl({ value: fileDescription, disabled: !enabled }),
      // filename: new FormControl({ value: null, disabled: !enabled }),
      // MD5: new FormControl({ value: null, disabled: !enabled }, [Validators.required])
      documentTypeId: new FormControl({ value: TipoDocumentoReembolso.FICHA_ODONTO, disabled: !enabled }, [Validators.required]),
    });
  }
  clearFinancialDocumentFiles() {
    this.formData.controls.medicalReceipt = this.createMedicalReceiptFile(false);
    this.formData.controls.financialReceipt = this.createFinancialReceiptFile(false);
    this.formData.controls.financialInvoice = this.createFinancialInvoiceFile(false);
    this.formData.controls.cirurgicalDescription = this.createCirurgicalDescriptionFile(false);
    this.formData.controls.anatomopathologicalReport = this.createAnatomopathologicalReportFile(false);
    this.formData.controls.medicalGuide = this.createMedicalGuide(false);
    this.formData.controls.medicalOrder = this.createMedicalOrder(false);
    this.formData.controls.odontoDescription = this.createOdontoRecordFile(false);
    this.formData.controls.financialInvoiceMedical = this.createFinancialInvoiceMedicalFile(false);
    this.formData.controls.odontoDescription = this.createOdontoRecordFile(false);
    this.formData.controls.odontoProcedureDescription = this.createOdontoProcedureDescriptionFile(false, '');
    // this.formData.controls.medicalPlan = this.createMedicalPlan(false);
    this.formData.controls.anestheticRecord = this.createAnestheticRecord(false);
    // this.formData.controls.pediatricRecord = this.createPediatricRecord(false);
    // this.formData.controls.partogram = this.createPartogram(false);
    this.formData.controls.otherFiles = this.createOtherFile(false);
    this.formData.controls.procedures.reset();
  }
  clearProcedures() {
    this.refundableGuides = [];
    if (this.formData.controls.medicalGuide.enabled) {
      this.formData.controls.medicalGuide = this.createMedicalGuide(true);
    }
    // this.formData.controls.medicalPlan = this.createMedicalPlan(false);
    this.formData.controls.procedures.reset();
    this.totalProceduresValue = 0;
  }
  saveSolicitation() {
    let postData = {
      acceptedTerms: this.formData.value.acceptedTerms as any,
      comments: this.formData.value.comments as any,
      refundTypeId: this.formData.value.refundTypeId as any,
      requestedValue: this.formData.value.requestedValue,
      beneficiaryId: this.formData.value.beneficiaryId as any,
      requestDate: new Date().toISOString() as any,
      participationDegreeId: this.formData.get("participationDegreeId")?.value,
      authorId: this.beneficiaries.find(x => x.titular).id,
      documents: [] as any,
      procedures: this.formData.value.procedures,
      executor: {
        cpf: this.formData.get('executor.cpf')?.value,
        councilNumber: this.formData.get('executor.councilNumber')?.value,
        councilId: this.formData.get('executor.councilId')?.value,
        council: this.formData.get('executor.council')?.value,
        uf: this.formData.get('executor.uf')?.value,
        nomeProfissional: this.formData.get('executor.profissionalExecutante')?.value,
      }
    };
    this.formData.markAllAsTouched();
    this.formData.updateValueAndValidity();
    if (this.formData.invalid) {
      this.toast.error('Por favor, preencha todos os campos obrigatórios!');
      return;
    }
    if (this.formData.get('medicalGuide.name')?.enabled) {
      postData.documents.push(this.formData.controls.medicalGuide.value);
    }
    // REFATORAR ESSA FUNÇÃO INICIO
    if (this.formData.get('financialInvoice.name')?.enabled) {
      const formToAdd = this.createFinancialInvoiceFile(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.financialInvoice.value);
      const financialInvoice: any = this.formData.controls.financialInvoice.controls.file.value;
      if (financialInvoice && financialInvoice.length > 0) {
        financialInvoice.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.requestedValue = postData.requestedValue == null ? this.formData.get('financialInvoice.requestedValue')?.value : this.formData.value.requestedValue;
      postData.documents.push(formToAdd.value);
    }
    if (this.formData.get('financialReceipt.name')?.enabled) {
      const formToAdd = this.createFinancialReceiptFile(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.financialReceipt.value);
      const financialReceipt: any = this.formData.controls.financialReceipt.controls.file.value;
      if (financialReceipt && financialReceipt.length > 0) {
        financialReceipt.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.requestedValue = postData.requestedValue == null ? this.formData.get('financialReceipt.requestedValue')?.value : this.formData.value.requestedValue;
      postData.documents.push(formToAdd.value);
    }
    if (this.formData.get('financialInvoiceMedical.name')?.enabled) {
      const formToAdd = this.createFinancialInvoiceMedicalFile(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.financialInvoiceMedical.value);
      const financialInvoiceMedical: any = this.formData.controls.financialInvoiceMedical.controls.file.value;
      if (financialInvoiceMedical && financialInvoiceMedical.length > 0) {
        financialInvoiceMedical.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.documents.push(formToAdd.value);
    }
    if (this.formData.get('medicalReceipt.name')?.enabled && this.formData.get('medicalReceipt.file')?.value != null) {
      const formToAdd = this.createMedicalReceiptFile(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.medicalReceipt.value);
      const medicalReceipt: any = this.formData.controls.medicalReceipt.controls.file.value;
      if (medicalReceipt && medicalReceipt.length > 0) {
        medicalReceipt.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.documents.push(formToAdd.value);
    }
    if (this.formData.get('cirurgicalDescription.name')?.enabled && this.formData.get('cirurgicalDescription.file')?.value != null) {
      const formToAdd = this.createCirurgicalDescriptionFile(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.cirurgicalDescription.value);
      const cirurgicalDescription: any = this.formData.controls.cirurgicalDescription.controls.file.value;
      if (cirurgicalDescription && cirurgicalDescription.length > 0) {
        cirurgicalDescription.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.documents.push(formToAdd.value);
    }
    if (this.formData.get('anatomopathologicalReport.name')?.enabled && this.formData.get('anatomopathologicalReport.file')?.value != null) {
      const formToAdd = this.createAnatomopathologicalReportFile(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.anatomopathologicalReport.value);
      const anatomopathologicalReport: any = this.formData.controls.anatomopathologicalReport.controls.file.value;
      if (anatomopathologicalReport && anatomopathologicalReport.length > 0) {
        anatomopathologicalReport.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.documents.push(formToAdd.value);
    }
    if (this.formData.get('odontoDescription.name')?.enabled && this.formData.get('odontoDescription.file')?.value != null) {
      const formToAdd = this.createOdontoRecordFile(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.odontoDescription.value);
      const odontoDescription: any = this.formData.controls.odontoDescription.controls.file.value;
      if (odontoDescription && odontoDescription.length > 0) {
        odontoDescription.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.documents.push(formToAdd.value);
    }
    if (this.formData.get('medicalOrder.name')?.enabled && this.formData.get('medicalOrder.file')?.value != null) {
      const formToAdd = this.createMedicalOrder(true);
      formToAdd.enable();
      formToAdd.patchValue(this.formData.controls.medicalOrder.value);
      const medicalOrder: any = this.formData.controls.medicalOrder.controls.file.value;
      if (medicalOrder && medicalOrder.length > 0) {
        medicalOrder.forEach((element: any) => {
          formToAdd.patchValue(element);
        });
      }
      postData.documents.push(formToAdd.value);
    }
    // REFATORAR ESSA FUNÇÃO FIM
    if (this.formData.controls.refundTypeId.value == TipoReembolso.EXAMES && postData.procedures != null) {
      // == this.formData.value.requestedValue ? true : false
      let soma = postData.procedures.reduce((soma: number, objeto: any) => {
        return soma + (objeto.value * objeto.quantity);
      }, 0);
      if (soma == 0) {
        if (postData.procedures.length > 1) {
          this.divergentValues = true;
          this.toast.error('Procedimento realizados com valores em branco!!');
          return;
        } else {
          this.divergentValues = true;
          this.toast.error('Procedimento realizado com valor em branco!!');
          return;
        }
      } else if (soma != this.formData.value.requestedValue) {
        this.divergentValues = true;
        this.toast.error('A soma dos procedimentos realizados não confere com o valor da soma!');
        return;
      }
      this.divergentValues = false;
    }
    if (this.formData.controls.refundTypeId.value == TipoReembolso.TERAPIAS && postData.procedures != null) {
      this.sessionErrorMessage = null;
      if (postData.procedures.filter((procedure: any) => {
        procedure.sessions.filter((session: any) => {
          session.notDone == true
        }).length == procedure.sessions.length
      }
      ).length == postData.procedures.length) {
        this.sessionErrorMessage = 'Sessões com datas em branco';
        this.toast.error('Sessões com datas duplicadas');
        return;
      }
      for (let index = 0; index < postData.procedures.length; index++) {
        const procedure = postData.procedures[index] as any;
        if (procedure.sessions.filter((session: any) => session.date == null && !session.notDone).length == 0) {
          let sessionDates = procedure.sessions.filter((session: any) => session.date != null && !session.notDone).map((session: any) => session.date);
          if (!this.hasDuplicates(sessionDates))
            procedure.sessions = sessionDates;
          else {
            this.sessionErrorMessage = 'Sessões com datas duplicadas';
            this.toast.error('Sessões com datas duplicadas');
            return;
          }
        } else {
          this.sessionErrorMessage = 'Sessões com datas em branco';
          this.toast.error('Sessões com datas em branco');
          return;
        }
      }
    }
    if (this.formData.get('otherFiles.file')?.value) {
      const otherFiles: any = this.formData.controls.otherFiles.controls.file.value;
      if (otherFiles && otherFiles.length > 0) {
        otherFiles.forEach((element: any) => {
          postData.documents.push({ MD5: element.MD5, contentType: element.contentType, documentTypeId: 18, file: element.file, fileName: element.fileName, size: element.size });
        });
      }
    }
    this.loading = true;
    console.log(postData)
    this.refundService.saveRefund(postData).subscribe({
      next: (res: any) => {
        this.loading = false;
        Swal.fire({
          icon: "success",
          title: "Solicitação concluída!",
          text: "Para verificar o andamento da solicitação, basta clicar em Minhas Solicitações abaixo, caso queira voltar para tela de Reembolso clique no botão 'Minhas solicitações'!",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Continuar",
          confirmButtonColor: "#1A428A",
          denyButtonText: "Entrar em contato",
          denyButtonColor: "#89837F"
        }).then((result) => {
          if (result.isDenied) {
            this.router.navigate(['minhas-solicitacoes-reembolso']);
          }
          this.formData.reset();
          this.formData.updateValueAndValidity();
        });
      }, error: (err: any) => {
        Swal.fire({
          icon: "error",
          title: "Erro ao enviar solicitação",
          text: err.Message,
        });
        this.loading = false;
      }
    });
  }
}
